import { createRoot } from "react-dom/client";
import React from "react";

import ContainerBoundaryContext from "common/boundary/ContainerBoundaryContext";

import { initDatadogRum } from "./datadog";

const render = (App: React.ComponentType<any>) => {
  initDatadogRum();

  const reactBody = document.getElementById("ReactBody");

  if (reactBody) {
    const root = createRoot(reactBody);

    root.render(
      <React.StrictMode>
        <ContainerBoundaryContext.Provider value={reactBody}>
          <App />
        </ContainerBoundaryContext.Provider>
      </React.StrictMode>,
    );
  }
};

export default render;
